import React, { useState, useEffect } from 'react'
import '../../assets/theme/theme.less'
import { LayoutComponent as Layout, TabsMenuComponent as TabsMenu } from '../../components'
import { Row, Col, List, message as alert, Modal, Select } from 'antd'
import CardContracts from './cardContract'
import { getContracts, repproveContract, approveContract, repproveSpirit, approveSpirit } from '../../redux/slices/contractsSlice'
import { useDispatch, useSelector } from 'react-redux'
import ApproveContract from '../../components/ApproveContract'
import { getContractTypeName } from '../../utils/functions'
import { getNotifications } from '../../redux/slices/monitorsSlice'
import moment from 'moment'

const { Option } = Select;

const ApprovalsContracts = () => {
    const dispatch = useDispatch()
    const [clicked, setClicked] = useState(0)
    const [openModal, setOpenModal] = useState(false)
    const [selectedContract, setSelectedContract] = useState(null)
    const [contractApproved, setContractApproved] = useState(false)
    const [error, setError] = useState(false)
    const [contractType, setContractType] = useState('all') // 'all' | 'senior' | 'sub' | 'rly'
    const [asaContracts, setAsaContracts] = useState([])
    const [spiritContracts, setSpiritContracts] = useState([])
    const { isLoading, success, contracts, isSubmit, successAction } = useSelector(state => state.contracts)

    const repprove = (idContract) => {
        setClicked(idContract)
        setContractApproved(false)
        
        // Check if we're dealing with a Spirit contract
        const contract = [...asaContracts, ...spiritContracts].find(c => c.id === idContract);
        const t = contract && parseInt(contract.tipoContrato, 10)
        const isSpirit = contract && [6, 7, 19].includes(t)
        
        const data = { idContract }
        
        if (isSpirit) {
            dispatch(repproveSpirit(data)).then((res) => {
                if(res?.error?.message) {
                    alert.error(res.payload)
                } else {
                    setTimeout(() => {
                        loadContracts()
                        // Refresh notifications after repproving a Spirit contract
                        dispatch(getNotifications())
                    }, 1000)
                }
            })
        } else {
            dispatch(repproveContract(data)).then((res) => {
                if(res?.error?.message) {
                    alert.error(res.payload)
                } else {
                    setTimeout(() => {
                        loadContracts()
                        // Refresh notifications after repproving a contract
                        dispatch(getNotifications())
                    }, 1000)
                }
            })
        }
    }

    const handleOpenModal = (contract) => {
        setSelectedContract(contract)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
        setSelectedContract(null)
        setError(false)
    }

    const approve = (idContract, quota, initialValue) => {
        const data = { idContract, quota, initialValue }
        if(quota === 0 || quota < 0 || quota === '') {
            setError(true)
        } else {
            setClicked(idContract)
            setContractApproved(true)
            setOpenModal(false)
            
            // Check if the contract type is Spirit
            if (selectedContract && [6, 7, 19].includes(parseInt(selectedContract.tipoContrato, 10))) {
                dispatch(approveSpirit(data)).then((res) => {
                    if(res?.error?.message) {
                        alert.error(res.payload)
                    } else {
                        setTimeout(() => {
                            loadContracts()
                            // Refresh notifications after approving a Spirit contract
                            dispatch(getNotifications())
                        }, 1000)
                    }
                })
            } else {
                dispatch(approveContract(data)).then((res) => {
                    if(res?.error?.message) {
                        alert.error(res.payload)
                    } else {
                        setTimeout(() => {
                            loadContracts()
                            // Refresh notifications after approving a contract
                            dispatch(getNotifications())
                        }, 1000)
                    }
                })
            }
        }
    }
    
    const loadContracts = () => {
        // Load ASA contracts (status 2)
        dispatch(getContracts({ status: 2 })).then(response => {
            if (!response.error) {
                setAsaContracts(response.payload.contracts || []);
            }
        });
        
        // Load Spirit contracts (status 7)
        dispatch(getContracts({ status: 7 })).then(response => {
            if (!response.error) {
                setSpiritContracts(response.payload.contracts || []);
            }
        });
    }
    
    const handleContractTypeChange = (value) => {
        setContractType(value);
    }
    
    // Get the appropriate contracts based on selected filter
    const getFilteredContracts = () => {
        const allContracts = [...asaContracts, ...spiritContracts];
        if (contractType === 'senior') {
            return allContracts.filter(c => {
                const x = parseInt(c.tipoContrato, 10)
                return x !== 6 && x !== 7 && x !== 19 && x !== 20 && x !== 21 && x !== 22
            });
        } else if (contractType === 'sub') {
            return allContracts.filter(c => parseInt(c.tipoContrato) === 7);
        } else if (contractType === 'rly') {
            return allContracts.filter(c => parseInt(c.tipoContrato) === 6 || parseInt(c.tipoContrato) === 19);
        } else if (contractType === 'capex-senior') {
            return allContracts.filter(c => parseInt(c.tipoContrato) === 20);
        } else if (contractType === 'capex-sub') {
            return allContracts.filter(c => parseInt(c.tipoContrato) === 21);
        } else if (contractType === 'bats') {
            return allContracts.filter(c => parseInt(c.tipoContrato) === 22);
        }
        // 'all'
        return allContracts;
    }
    
    // Get the filtered contracts
    const filteredContracts = getFilteredContracts();
    
    useEffect(() => {
        loadContracts();
        // Initialize notifications
        dispatch(getNotifications());
    }, [dispatch]);
    
    // Add a separate effect to refresh notifications periodically
    useEffect(() => {
        const notificationRefreshInterval = setInterval(() => {
            dispatch(getNotifications());
        }, 30000); // Refresh every 30 seconds
        
        return () => clearInterval(notificationRefreshInterval);
    }, [dispatch]);
    
    return (
        <Layout width>
            <Row>
                <Col md={24}>
                    <h1 className="title page-title">Aprovações</h1>
                </Col>
                <Col md={24} className="mt-15 d-flex align-center">
                    <div className="d-flex align-center m-auto">
                        <TabsMenu type="approvals" />
                    </div>
                </Col>
            </Row>
            <Row className="mt-25">
                <Col md={24} className="mb-15 d-flex align-items-center">
                    <span className="mr-10">Filtrar por tipo:</span>
                    <Select 
                        defaultValue="all" 
                        style={{ width: 200 }} 
                        onChange={handleContractTypeChange}
                        value={contractType}
                    >
                        <Option value="all">Todos os contratos</Option>
                        <Option value="senior">{getContractTypeName(1)}</Option>
                        <Option value="sub">{getContractTypeName(7)}</Option>
                        <Option value="rly">{getContractTypeName(6)}</Option>
                        <Option value="capex-senior">{getContractTypeName(20)}</Option>
                        <Option value="capex-sub">{getContractTypeName(21)}</Option>
                        <Option value="bats">{getContractTypeName(22)}</Option>
                    </Select>
                </Col>
                {isLoading ? 'Carregando' : success ?
                        <List
                            grid={{ gutter: 16, column: 3}}
                            dataSource={filteredContracts}
                            pagination
                            renderItem={item => (
                                <List.Item>
                                    <CardContracts 
                                        error={error} 
                                        contract={item} 
                                        clicked={clicked} 
                                        isSubmit={isSubmit} 
                                        success={successAction} 
                                        repprove={repprove} 
                                        contractApproved={contractApproved} 
                                        onApproveClick={handleOpenModal}
                                    />
                                </List.Item>
                            )}
                        /> : 'Houve um erro ao carregar os contratos'
                }
            </Row>

            <Modal
                centered
                visible={openModal}
                footer={null}
                closable={false}
                maskClosable={false}
                className="modal-deny"
                width="70vw"
            >
                {selectedContract && (
                    <ApproveContract 
                        error={error} 
                        contract={selectedContract} 
                        handleModal={handleCloseModal} 
                        approve={approve} 
                    />
                )}
            </Modal>
        </Layout>
    )
}

export default ApprovalsContracts